const TOOLBAR_FONT = "'Helvetica Neue', Helvetica, Arial, sans-serif";

// The redesign's rounded outline control: Buscar, Añadir filtro, Exportar and the filter inputs.
const PILL = {
    height: '30px',
    borderRadius: '20px',
    fontFamily: TOOLBAR_FONT,
    fontSize: '14px',
    color: '#000',
};

// List page around the table (the table itself is styled by CustomDatagrid). Margins as in the XD:
// toolbar controls and cell text 62px from the content edge, table rows 45px.
export const RA_LIST_CUSTOM_STYLE = {
    // The gray band under the page header; added filters wrap inside it.
    '& .RaList-actions': {
        backgroundColor: '#BCBCBC',
        padding: '16px 62px',
        flexWrap: 'wrap',
        justifyContent: 'flex-start',
        alignItems: 'center',
        '@media (max-width: 1024px)': {padding: '16px'},
    },
    // Only as wide as its inputs, so "Añadir filtro" follows Buscar and "Exportar" goes right. Without
    // react-admin's 4px under the inputs, the controls sit in the middle of the band.
    '& .RaFilter-form': {
        flex: '0 1 auto',
        alignItems: 'center',
        minHeight: 'unset',
        paddingBottom: 0,
        columnGap: '16px',
        marginRight: '16px',
    },
    // Each filter: the pill and its remove button share a center line. `&&` doubles the class so these
    // beat react-admin's and MUI's own margins (8px under the button, the dense field's 8px/4px).
    '& .RaFilterForm-filterFormInput': {alignItems: 'center'},
    '&& .RaFilterFormInput-hideButton': {margin: 0},
    '& .RaFilterForm-filterFormInput input::placeholder': {color: '#000', opacity: 1},
    '&& .RaFilterForm-filterFormInput .MuiFormControl-root': {margin: '4px 0'},
    '& .RaFilterForm-filterFormInput .MuiOutlinedInput-root': {...PILL, minWidth: '190px', backgroundColor: 'transparent'},
    // MUI sizes the text box for a 40-56px field; fit it to the 30px pill so it doesn't spill below.
    // Flex centers a select's value too (it renders in a div, not an input).
    '& .RaFilterForm-filterFormInput .MuiOutlinedInput-input': {
        height: '100%',
        padding: '0 14px',
        boxSizing: 'border-box',
        display: 'flex',
        alignItems: 'center',
    },
    // The legend sizes the gap in the border for the floating label: same font as the label (0.75 × 14px);
    // its span inherits it, or the global `span` rule makes the gap wider than the label.
    '& .RaFilterForm-filterFormInput .MuiOutlinedInput-notchedOutline': {
        borderColor: '#000',
        '& legend': {fontFamily: TOOLBAR_FONT, fontSize: '10.5px'},
        '& legend span': {font: 'inherit', letterSpacing: 'normal'},
    },
    // Label at the pill's font size, centered in the 30px pill until it floats onto the border.
    '& .RaFilterForm-filterFormInput .MuiInputLabel-root': {
        fontFamily: TOOLBAR_FONT,
        fontSize: '14px',
        lineHeight: '18px',
        color: '#000',
        transform: 'translate(14px, 6px) scale(1)',
    },
    '& .RaFilterForm-filterFormInput .MuiInputLabel-shrink': {transform: 'translate(14px, -9px) scale(0.75)'},
    // Países: the chips (and the pill, when they wrap) fit inside the border; `&&` beats MUI's Autocomplete padding.
    '&& .RaFilterForm-filterFormInput .MuiAutocomplete-inputRoot': {height: 'auto', minHeight: '30px', paddingTop: '2px', paddingBottom: '2px'},
    '&& .RaFilterForm-filterFormInput .MuiAutocomplete-inputRoot .MuiAutocomplete-input': {height: '24px', padding: '0 4px'},
    '&& .RaFilterForm-filterFormInput .MuiAutocomplete-tag': {height: '24px', margin: '1px 3px'},
    // Without the toolbar's own 4px/8px above and below its buttons, they line up with the inputs.
    '&& .RaList-actions .MuiToolbar-root': {alignItems: 'center', paddingTop: 0, paddingBottom: 0},
    '& .MuiToolbar-root': {
        flex: '1',
        justifyContent: 'space-between',
        backgroundColor: 'transparent',
        minHeight: 'unset',
    },
    // Icon after the label, as in the design.
    '& .RaList-actions .MuiButton-root': {
        ...PILL,
        padding: '0 14px',
        border: '1px solid #000',
        textTransform: 'none',
        flexDirection: 'row-reverse',
        gap: '8px',
        '& .MuiButton-startIcon': {margin: '0'},
    },
    '& .RaList-content': {
        margin: '16px 45px 32px',
        boxShadow: 'none',
        borderRadius: 0,
        '@media (max-width: 1024px)': {margin: '8px 0 24px'},
    },
    '& .column-totalInvestmentFormatted': {textAlign: 'right'},
    '& .MuiSvgIcon-root': {color: 'black', fill: 'black'},
};
